<template>
  <Wrapper class="app app--auth">
    <div class="app-content">
      <div class="block block-shadow py-30 block-rounded">
        <header class="block-header text-center" v-if="isDefaultLogo != ''">
          <img :src="isDefaultLogo" alt="brand logo" />
        </header>
        <div>
          <div class="block-content p-0">
            <h1 class="block-title text-center">
              Sign up using your email
            </h1>
          </div>
          <div v-if="errors.length" class="block-content">
            <div class="alert alert-danger">
              <div v-for="(error, index) in errors" :key="index">
                {{ error.message }}
              </div>
            </div>
          </div>
          <div class="block-content">
            <form class="form" @submit.prevent="handleFormSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="form-material pt-0">
                      <input
                        type="text"
                        v-model="user.firstName"
                        name="firstName"
                        placeholder="First Name"
                        class="form-control no-focus"
                        required
                      />
                      <label for="firstName" class="sr-only">First Name</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="form-material pt-0">
                      <input
                        type="text"
                        v-model="user.lastName"
                        name="lastName"
                        placeholder="Last Name"
                        class="form-control no-focus"
                        required
                      />
                      <label for="lastName" class="sr-only">Last Name</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-material pt-0">
                  <input
                    type="email"
                    v-model="user.email"
                    name="email"
                    @blur="checkEmail"
                    placeholder="Email"
                    class="form-control no-focus"
                    required
                  />
                  <label for="email" class="sr-only">Email</label>
                </div>
              </div>
              <div class="form-group">
                <div class="form-material pt-0">
                  <input
                    type="password"
                    v-model="user.password"
                    name="password"
                    id="password"
                    class="form-control no-focus"
                    placeholder="Password"
                    required
                  />
                  <label for="password" class="sr-only">Password</label>
                </div>
              </div>
              <div class="form-group">
                <div class="form-material pt-0">
                  <input
                    type="password"
                    v-model="user.confirmPassword"
                    name="confirmPassword"
                    id="confirmPassword"
                    class="form-control no-focus"
                    placeholder="Confirm password"
                    required
                  />
                  <label for="password" class="sr-only">Confirm Password</label>
                </div>
              </div>
              <div class="form-group mt-30">
                <button
                  type="submit"
                  class="btn btn-gd btn-gd-primary btn-block"
                  style="color: #fff"
                  :disabled="isLoading"
                >
                  <Spinner v-if="isLoading" theme="currentColor" />
                  <span v-else>Sign up</span>
                </button>
              </div>
            </form>
            <div class="block-content">
              <div class="sep sep--or">
                <span>OR</span>
              </div>
            </div>
            <div class="block-content text-center">
              Already have an account?
              <router-link to="/" class="">Sign In</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import Color from "color";
import { mapActions, mapGetters } from "vuex";
import types from "@/store/auth/types";
import axios from "@/helpers/base";
import { signupMailer } from "@/helpers/mailer";
import Wrapper from "./Wrapper";
import Spinner from "@/components/Spinner";
import { socketSender } from "@/helpers/socket";
import _ from "lodash";

export default {
  components: {
    Wrapper,
    Spinner
  },
  data() {
    return {
      isLoading: false,
      errors: [],
      messages: [],
      roles: null,
      user: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        confirmPassword: null
      },
      isDefaultLogo: "",
      headroomLogo: require("@/assets/media/brand.svg")
    };
  },
  async mounted() {
    this.fetchUserRoles();

    await this.$store.dispatch("fetchOptions");

    let defaultLogoStatus = _.filter(this.options, ["key", "defaultlogo.main"]);
    if (
      defaultLogoStatus.length &&
      defaultLogoStatus[0].value.status == false
    ) {
      let defaultLogo = _.filter(this.options, ["key", "defaultlogo.sub"]);
      if (defaultLogo.length && defaultLogo[0].value.image) {
        this.isDefaultLogo = defaultLogo[0].value.image;
      } else {
        this.isDefaultLogo = this.headroomLogo;
      }
    } else {
      this.isDefaultLogo = this.headroomLogo;
    }
  },
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  methods: {
    ...mapActions({
      [types.AUTH_SET]: types.AUTH_SET
    }),
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    }),
    async fetchUserRoles() {
      try {
        const { data } = await axios.get("/roles");
        this.roles = data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async handleFormSubmit() {
      this.isLoading = true;

      if (this.checkForm()) {
        this.isLoading = false;
        return;
      }

      try {
        const UserRoles = this.roles
          .filter(role => role.value === 0)
          .map(role => ({ roleId: role.id }));
        const background = Math.floor(Math.random() * 16777215).toString(16);
        const color = Color("#" + background).isLight ? "fff" : "333";
        const firstName = this.user.firstName.replace(/ .*/, "");
        const lastName = this.user.lastName.replace(/ .*/, "");
        let user = {
          ...this.user,
          displayName: firstName,
          avatar: `https://ui-avatars.com/api/?name=${firstName}+${lastName}&background=${background}&color=${color}&size=500&font-size=.35&bold=true`,
          UserRoles
        };
        /**
         * SOCKET: new user register
         */
        let logContent = `User ${firstName} ${lastName} has registered on QSpace using the email ${this.user.email}`;
        socketSender("userRegister", logContent);

        const result = await axios.post("/users", user);
        await signupMailer({
          to: user.email,
          displayName: user.displayName
        });

        if (result.status === 200) {
          await this.userLogin();
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.response) {
          this.errors = error.response.data.errors;
          return;
        }
        this.errors.push({ message: error.message });
      }
    },
    checkForm() {
      this.errors = [];

      if (!this.user.firstName || !this.user.lastName) {
        this.errors.push({ message: "Given and surname is required." });
      }

      if (!this.user.email) {
        this.errors.push({ message: "Email is required." });
      }

      if (this.user.password.length < 6) {
        this.errors.push({
          message: "Password should be at least 6 characters long."
        });
      }

      if (!this.user.password) {
        this.errors.push({ message: "Password is required." });
      }

      if (this.user.password !== this.user.confirmPassword) {
        this.errors.push({ message: "Password did not match." });
      }

      if (this.errors.length) {
        return true;
      }
    },
    async checkEmail() {
      this.errors = [];
      if (!this.user.email) {
        this.errors.push({ message: "Email is required." });
        return;
      }

      try {
        const { data: existingEmail } = await axios.get(
          `/users/?email=${this.user.email}&paranoid=false`
        );

        if (existingEmail.data) {
          this.emailTaken = true;
          this.errors.push({ message: "Email is already taken." });
        } else {
          this.emailTaken = false;
        }
      } catch (error) {
        this.emailTaken = false;
        this.errors.push({ message: error.message });
      }
    },
    async userLogin() {
      const user = {
        email: this.user.email,
        password: this.user.password
      };

      try {
        const result = await this.AUTH_SET(user);

        if (result) {
          this.$router.push("/");
        }
      } catch (error) {
        this.errors.push({ message: error.response });
      }
    }
  }
};
</script>
<style lang="scss">
.router-link {
  &-active {
    color: var(--primary, $brand-primary);
  }
}
</style>
